<template>
<BaseForm
    class="reply-form"
    v-model.trim="text"
    v-focus.deep
    @submit="onSubmit"
    :placeholder="placeholder"
    :disabled="isLoading"
    :isLoading="isLoading">
    <template #buttonText>
        Reply
    </template>
</BaseForm>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseForm from './BaseForm'
import * as C from '@shared/constants'

export default {
    name: 'ReplyForm',
    props: {},
    data: vm => ({
        text: '',
        isLoading: false,
    }),
    computed: {
        ...mapGetters(['replyToSuggestion']),
        placeholder: vm => {
            const { name } = vm.replyToSuggestion.user
            return `Reply to ${name}`
        }
    },
    watch: {
        replyToSuggestion: {
            handler () {
                this.text = this.replyToSuggestion?.reply?.text || ''
            },
            immediate: true
        }
    },
    methods: {
        async onSubmit () {
            try {
                this.isLoading = true

                const { id, reply } = this.replyToSuggestion

                const payload = {
                    suggestionId: id,
                    text: this.text,
                    createdAt: reply?.createdAt, // Keep the original date.
                }
                await this.$store.dispatch('updateSuggestionReply', payload)

                this.text = '' // clear text to show placeholder
            } finally {
                this.isLoading = false
            }
        },
    },
    components: {
        BaseForm,
    }
}
</script>

<style lang="scss" scoped>
</style>
